
import TableComponent from "components/table/TableComponent";
import { columns, rows } from "components/table/table_1";
import { columns as columns_2, rows as rows_2 } from "components/table/table_2";
import { columns as columns_3, rows as rows_3 } from "components/table/table_3";
import { columns as columns_4, rows as rows_4 } from "components/table/table_4";

export const accordions = [
  {
    title:
      "1․ «Ազգային Դպրոցի» 1-4-րդ դասարաններում Ազգային կրթակարգի քաղաքակրթական բաղադրիչի ապահովման առարկայացանկի ձևավորման սկզբունք­ները",
    content: (
      <div className="flex flex-col gap-8 my-8">
        <ul className="ml-4 list-decimal pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            <strong>«Ես և շրջակա աշխարհը» առարկան՝</strong> որպես 2-4-րդ
            դասարաններում մարդուն և նրա շրջակա աշխարհն ուսումնասիրող մեկ
            ինտեգրված ուսումնական առարկա՝ ապահովելու է ԲՏՃՄ, «Ֆիզիկական
            կրթություն և անվտանգ կենսագործունեություն», «Հայրենագիտություն»,
            «Հասարակություն, հասարակական գիտություններ» բնագավառների
            ազգային-քաղաքակրթական բովանդակությունը,
          </li>
          <li>
            <strong>«Մայրենի» առարկան՝</strong> որպես 1-4-րդ դասարաններում
            «Հայոց լեզու և գրականություն» բնագավառի ազգային-քաղաքակրթական
            բովանդակությունն ապահովող միասնական առարկա։
          </li>
        </ul>
        <TableComponent columns={columns} rows={rows} />
      </div>
    ),
  },
  {
    title:
      "2․ «Ազգային Դպրոցի» 5-6-րդ դասարաններում Ազգային կրթակարգի քաղաքակրթական բաղադրիչի ապահովման առարկայացանկի ձևավորման սկզբունք­ները",
    content: (
      <div className="flex flex-col gap-8 my-8">
        <ul className="ml-4 list-decimal pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            <strong>
              «Իմ հայրենիքը» և «Իմ հայրենիքն ու աշխարհը» առարկաներն՝
            </strong>
            որպես Հայաստանն ու հայ ժողովրդը, համաշխարհային պատմությունը,
            մշակույթը, կրոնը, աշխարհագրությունը, հասարակական կյանքի ոլորտներն
            ուսումնասիրող ինտեգրված ուսումնական առարկաներ, ապահովելու են՝
            «Հայրենագիտություն» և «Հասարակություն, հասարակական գիտություններ»
            բնագավառների ազգային-քաղաքակրթական բովանդակությունը՝
            համապատասխանաբար 5-րդ և 6-րդ դասարաններում։
          </li>
          <li>
            <strong>«Մայրենի» առարկան՝</strong> որպես 5-6-րդ դասարաններում
            «Հայոց լեզու և գրականություն» բնագավառի ազգային-քաղաքակրթական
            բովանդակությունն ապահովող միասնական առարկա։
          </li>
        </ul>
        <TableComponent columns={columns_2} rows={rows_2} />
      </div>
    ),
  },
  {
    title:
      "3․ «Ազգային Դպրոցի» 7-9-րդ դասարաններում Ազգային կրթակարգի քաղաքակրթական բաղադրիչի ապահովման առարկայացանկի ձևավորման սկզբունք­ները",
    content: (
      <div className="flex flex-col gap-8 my-8">
        <ul className="ml-4 list-decimal pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            <strong>
              «Աշխարհագրություն» և «Հայաստանի Աշխարհագրություն» առարկաները՝
            </strong>
            որպես Պատմական Հայաստանի և Հայաստանի Հանրապետության
            աշխարհագրությունը, Երկակագնդի աշխարհագրական թաղանթը, Համաշխարհային
            տնտեսությունն ու բնակչությունը, Աշխահի քաղաքական քարտեզն
            ուսումնասիրող առարկաներ, ապահովելու են՝ «Հայրենագիտություն» և
            «Հասարակություն, հասարակական գիտություններ», ԲՏՃՄ բնագավառների
            ազգային-քաղաքակրթական բովանդակությունը՝ համապատասխանաբար
            «Աշխարհագրություն» առարկան 7-րդ և 8-րդ դասարաններում, իսկ «Հայաստանի
            Աշխարհագրություն» առարկան 9-րդ դասարանում։
          </li>
          <li>
            <strong>«Հայոց լեզու» և «Գրականություն» առարկաները՝</strong> որպես
            7-9-րդ դասարաններում «Հայոց լեզու և գրականություն» բնագավառի
            ազգային-քաղաքակրթական բովանդակությունն ապահովող առաձին առարկաներ։
          </li>
          <li>
            <strong>«Հայոց պատմություն» առարկան՝</strong> որպես 7-9-րդ
            դասարաններում «Հայրենագիտություն» բնագավառի ազգային-քաղաքակրթական
            բովանդակությունն ապահովող առարկա
          </li>
          <li>
            <strong>
              «Համաշխարհային պատմություն» և «Հասարակագիտություն» առարկաներն՝
            </strong>
            որպես 7-9-րդ դասարաններում համաշխարհային պատմություն և հասարակական
            կյանքի ոլորտներ ուսումնասիրող առաձին առարկաներ ապահովելու են
            «Հասարակություն, հասարակական գիտություններ» բնագավառի
            ազգային-քաղաքակրթական բովանդակությունը։
          </li>
        </ul>
        <TableComponent columns={columns_4} rows={rows_4} />
      </div>
    ),
  },
  {
    title:
      "4․ «Ազգային Դպրոցի» 10-12-րդ դասարաններում Ազգային կրթակարգի քաղաքակրթական բաղադրիչի ապահովման առարկայացանկի ձևավորման սկզբունք­ները",
    content: (
      <div className="flex flex-col gap-8 my-8">
        <ul className="ml-4 list-decimal pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            <strong>«Աշխարհագրություն» առարկան՝</strong>
            որպես 10-12-րդ դասարաններում Հայկական քաղաքակրության
            աշխահագրությունը, Երկակագնդի աշխարհագրական թաղանթը, Համաշխարհային
            տնտեսությունն ու բնակչությունը, Աշխահի քաղաքական քարտեզը,
            համամոլորակային հիմնախնդիրներն ուսումնասիրող առարկա, ապահովելու է՝
            «Հայրենագիտություն» և «Հասարակություն, հասարակական գիտություններ»,
            ԲՏՃՄ բնագավառների ազգային-քաղաքակրթական բովանդակությունն ապահովող
            առաձին առարկա համապատասխանաբար 5-րդ և 6-րդ դասարաններում։
          </li>
          <li>
            <strong>«Հայոց լեզու» և «Հայ Գրականություն» առարկաներն՝</strong>
            որպես 10-12-րդ դասարաններում «Հայոց լեզու և գրականություն» բնագավառի
            ազգային-քաղաքակրթական բովանդակությունն ապահովող առաձին առարկաներ։
          </li>
          <li>
            <strong>«Հայոց պատմություն» առարկան՝</strong> որպես 7-9-րդ
            դասարաններում «Հայրենագիտություն» բնագավառի ազգային-քաղաքակրթական
            բովանդակությունն ապահովող առարկա:
          </li>
          <li>
            <strong>«Հասարակագիտություն» առարկան՝</strong>
            որպես 10-12-րդ դասարաններում հասարակական կյանքի ոլորտներ
            ուսումնասիրող առաձին առարկա ապահովելու է «Հասարակություն,
            հասարակական գիտություններ» բնագավառի ազգային-քաղաքակրթական
            բովանդակությունը։
          </li>
        </ul>
        <TableComponent columns={columns_3} rows={rows_3} />
      </div>
    ),
  },
];
